import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable()
export class FeatureAccessService {
  features = environment.featuresAccess;


  constructor() {
    console.log("featuresAccess :",this.features);
  }

  hasAccess(feature, element: string): boolean {
    return this.features ?this.features[feature].includes(element):false;
  }

  static hasAccess(feature: any, element: string,): boolean {
    return environment.featuresAccess?environment.featuresAccess[feature].includes(element):false;
  }

  static hasAccessUo(feature: any, element: string,): boolean {
    const featuresAccess = environment.featuresAccess[feature];
    return featuresAccess && element?featuresAccess.some(uo=> String(element).toLowerCase().includes(uo)) :false;
  }
}





// WEBPACK FOOTER //
// ./src/app/service/feature-access.service.ts